import React from "react";

import { Tag } from "antd";
import { BaseTagProps } from "./types";

import "./styles.css";

const BaseTag = ({
  label,
  className,
  size = "large",
  icon,
  color,
  hasRoundCorners = false,
  thumbnail,
  ...props
}: BaseTagProps) => {
  const onPreventMouseDown = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Tag
      onMouseDown={onPreventMouseDown}
      className={`body-s-regular base-tag base-tag-${size} ${className ? `${className}-tag` : ""} ${hasRoundCorners && "round-tag"} ${thumbnail?.src ? "base-tag--has-thumbnail" : ""}`}
      style={{ backgroundColor: `${color}33`, borderColor: color }}
      icon={icon}
      {...props}
    >
      {thumbnail?.src ? (
        <>
          <span className="base-tag__thumbnail">
            <img
              src={thumbnail?.src}
              alt={thumbnail?.alt || ""}
              loading="lazy"
            />
          </span>

          <span className="base-tag__label">{label}</span>
        </>
      ) : (
        label
      )}
    </Tag>
  );
};

export default BaseTag;
